import get from 'lodash/get';
import { LOCALES } from 'prismic/config';
import isClient from './isClient';

const getLocalePrefix = (asPath: string) => {
  const localePrefix = get(LOCALES, asPath.split('/')[1], '');
  return localePrefix;
};

export const getClientLocalePrefix = () => {
  return isClient() ? getLocalePrefix(window.location.pathname) : 'de';
};

export default getLocalePrefix;
